import { createFileRoute } from '@tanstack/react-router'
import { AlertsOverview } from '@/features/alerts/overview'

export const Route = createFileRoute('/_authenticated/alerts/')({
  component: AlertsOverview,
})

